import request from '../utils/request.js'

export default {
	getList(params) {
		return request.post(`jobs/lists`, params).then(res => res.data);
	},
	add(params) {
		return request.post(`jobs/add`, params).then(res => res.data);
	},
	edit(params) {
		return request.post(`jobs/add`, params).then(res => res.data);
	},
	details(params) {
		return request.post(`jobs/details`, params).then(res => res.data);
	},
	delete(params) {
		return request.post(`jobs/del`, params).then(res => res.data);
	},
	selectList(params) {
		return request.post(`jobs/selectlist`, params).then(res => res.data);
	},
	importJobs(params) {
		return request.upload(`jobs/import_jobs`, params).then(res => res.data);
	},

}


// WEBPACK FOOTER //
// ./src/api/jobs.js